import React from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

export type ViewMode = 'day' | 'week' | 'month';

interface QuickDateFiltersProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  onNavigate?: (direction: 'prev' | 'next') => void;
  showNavigation?: boolean;
}

/**
 * Quick date filter buttons with context-aware navigation
 * - Day view: Navigate by days
 * - Week view: Navigate by weeks
 * - Month view: Navigate by months
 */
const QuickDateFilters: React.FC<QuickDateFiltersProps> = ({
  currentView,
  onViewChange,
  onNavigate,
  showNavigation = true,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      <ButtonGroup variant="contained" size="medium">
        <Button
          startIcon={<TodayIcon />}
          variant={currentView === 'day' ? 'contained' : 'outlined'}
          onClick={() => onViewChange('day')}
        >
          Today
        </Button>
        <Button
          startIcon={<DateRangeIcon />}
          variant={currentView === 'week' ? 'contained' : 'outlined'}
          onClick={() => onViewChange('week')}
        >
          Week
        </Button>
        <Button
          startIcon={<CalendarMonthIcon />}
          variant={currentView === 'month' ? 'contained' : 'outlined'}
          onClick={() => onViewChange('month')}
        >
          Month
        </Button>
      </ButtonGroup>

      {showNavigation && onNavigate && (
        <ButtonGroup variant="outlined" size="medium">
          <Button
            startIcon={<NavigateBeforeIcon />}
            onClick={() => onNavigate('prev')}
          >
            Previous
          </Button>
          <Button
            endIcon={<NavigateNextIcon />}
            onClick={() => onNavigate('next')}
          >
            Next
          </Button>
        </ButtonGroup>
      )}
    </Box>
  );
};

export default QuickDateFilters;
